import { FC } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Card, Typography, Space } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const SignUpPage: FC = () => {
  const { loginWithRedirect, isLoading } = useAuth0();
  const navigate = useNavigate();

  const handleSignUp = async () => {
    try {
      await loginWithRedirect({
        authorizationParams: {
          screen_hint: 'signup',
        },
        appState: {
          returnTo: '/',
        },
      });
    } catch (error) {}
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={2}>Sign Up</Title>
            <Text type="secondary">Create a new account to get started.</Text>
          </div>

          <Button
            type="primary"
            size="large"
            icon={<UserAddOutlined />}
            onClick={handleSignUp}
            loading={isLoading}
            block
            style={{ height: 48 }}
          >
            Sign Up with Auth0
          </Button>

          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">
              Already have an account?{' '}
              <Button
                type="link"
                onClick={() => navigate('/signin')}
                style={{ padding: 0 }}
              >
                Sign In
              </Button>
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default SignUpPage;
